// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const weavile: PokeData = {
  "id": 461,
  "name": "weavile",
  "height": 11,
  "weight": 340,
  "base_experience": 179,
  "types": [
    PokeType.DARK,
    PokeType.ICE
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "leer",
    "blizzard",
    "agility",
    "quick-attack",
    "screech",
    "swift",
    "fury-swipes",
    "slash",
    "feint-attack",
    "icy-wind",
    "metal-claw",
    "beat-up",
    "taunt",
    "revenge",
    "snatch",
    "assurance",
    "embargo",
    "fling",
    "punishment",
    "poison-jab",
    "dark-pulse",
    "night-slash",
    "nasty-plot",
    "ice-shard",
    "hone-claws"
  ],
  "moves": [
    "scratch",
    "leer",
    "blizzard",
    "quick-attack",
    "metal-claw",
    "snatch",
    "poison-jab",
    "dark-pulse",
    "night-slash",
    "ice-shard",
    "dark-bargain",
    "crunch",
    "avalanche"
  ],
  "evolution_chain": {
    "id": 109,
    "item": null,
    "species": [
      {
        "name": "sneasel",
        "order": 245,
        "types": [
          PokeType.DARK,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "weavile",
        "order": 246,
        "types": [
          PokeType.DARK,
          PokeType.ICE
        ],
        "evolves_from_species_id": 215,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "sneasler",
        "order": 903,
        "types": [
          PokeType.FIGHTING,
          PokeType.POISON
        ],
        "evolves_from_species_id": 215,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 91,
    "speed": 157,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
